import Link from 'next/link'

import { DirectoryLinkHref, DirectoryLinkAs } from 'utils/DirectoryParser'
import { StylizedA, FacetCountBadge, StyledFacet, FacetText } from './Styled'
import { fetchFontAwesomeFacetIcon } from './Utils'

const SearchFacet = ({ type, checked, facetName, count, directoryLinkInformation }) => {
  if (!directoryLinkInformation || !count) {
    return null
  }

  const icon = fetchFontAwesomeFacetIcon(type, checked)
  const href = DirectoryLinkHref(directoryLinkInformation)
  const as = DirectoryLinkAs(directoryLinkInformation)
  return (
    <Link scroll={false} href={href} as={as}>
      <StylizedA color={checked ? 'inverseColor' : 'textColor'}>
        <StyledFacet>{icon}</StyledFacet>
        <FacetText checked={checked}>{facetName}</FacetText>
        {!checked && (
          <FacetCountBadge>
            {count >= 1000 ? Math.round(count / 1000) + 'k' : count}
          </FacetCountBadge>
        )}
      </StylizedA>
    </Link>
  )
}

export default SearchFacet
